export const en = {
    'add-keywords': 'Add to keywords',
    remove: 'Delete'
};
